import { render, staticRenderFns } from "./DetailRatingItem.vue?vue&type=template&id=d8d8c880&scoped=true"
import script from "./DetailRatingItem.vue?vue&type=script&lang=js"
export * from "./DetailRatingItem.vue?vue&type=script&lang=js"
import style0 from "./DetailRatingItem.vue?vue&type=style&index=0&id=d8d8c880&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d8c880",
  null
  
)

export default component.exports